    // Search Filter blog
    
    function filterApply(value, div) {
    let title = document.querySelectorAll(".blog-post-title");
    let searchValue = value.toLowerCase();
          console.log("call")

    title.forEach((e) => {
      let dataTitle = e.getAttribute("data-post-title").toLowerCase();
      let titleParentDiv = e.closest(".filter_box");

      if (titleParentDiv) {
        if (dataTitle.indexOf(searchValue) > -1) {
          console.log("if")
          titleParentDiv.classList.add("active");
        } else {
          console.log("else")
          titleParentDiv.classList.remove("active");
        }
      }
    });
  }
  
document.addEventListener("DOMContentLoaded", function () {
  let blockFilter = document.querySelector('[id^="filter-"]');
  let clearButton = document.querySelector(".clear-search-btn");

  if (blockFilter && clearButton) {
    // Show/hide clear button based on input
    function toggleClearBtn() {
      if (blockFilter.value.trim() !== "") {
        clearButton.style.display = "block";
      } else {
        clearButton.style.display = "none";
      }
    }

    blockFilter.addEventListener("input", function () {
      filterApply(this.value, this.closest(".page-width"));
      toggleClearBtn();
    });

    // When clicking the clear (X) button
    clearButton.addEventListener("click", function () {
      blockFilter.value = "";
      filterApply("", blockFilter.closest(".page-width"));
      toggleClearBtn();
      blockFilter.focus(); // Optional: Focus back to input
    });

    // Optional: handle browser's native clear button as well
    blockFilter.addEventListener("search", function () {
      filterApply("", this.closest(".page-width"));
      toggleClearBtn();
    });
  }
});


  // Blog Filter - Based on blog-tag

  // document.addEventListener('DOMContentLoaded', function () {
  //   const filterDropdown = document.getElementById('blog-category-filter');
    
  //   if (filterDropdown) {
  //     filterDropdown.addEventListener('change', function () {
  //       const tag = this.value;
  //       const blogHandle = "{{ blog.handle }}";

  //       const url = tag
  //         ? `/blogs/${blogHandle}/tagged/${tag}?view=ajax`
  //         : `/blogs/${blogHandle}?view=ajax`;

  //       fetch(url)
  //         .then(response => response.text())
  //         .then(html => {
  //           const parser = new DOMParser();
  //           const doc = parser.parseFromString(html, 'text/html');
  //           const posts = doc.querySelector('.blog-post-list-boxs');
  //           document.querySelector('.blog-post-list-boxs').innerHTML = posts.innerHTML;
  //         });
  //     });
  //   }
  // });